import { UI_CODE } from '@/common/resources/const'
import cookie from '@/common/utils/cookie'
import { beforeGNBEnter } from '@/common/utils/common'
import {
  PATH_NAME_COIN,
  PATH_NAME_COUPON,
  PATH_NAME_LIKE_CHANNEL,
  PATH_NAME_LIKE_MOVIE,
  PATH_NAME_LIKE_PROGRAM,
  PATH_NAME_LIKE_THEME,
  PATH_NAME_MY,
  PATH_NAME_RESERVE_WATCH,
  PATH_NAME_SUBSCRIPTION_TICKET,
  PATH_NAME_USE_LIST_DOWNLOAD_HISTORY,
  PATH_NAME_USE_LIST_MOVIE_HISTORY,
  PATH_NAME_USE_LIST_VOD_HISTORY,
  PATH_NAME_VOUCHER_LIST_PACKAGE,
  PATH_NAME_VOUCHER_LIST_SINGULAR,
  PATH_NAME_DEVICE_HISTORY,
} from '@/common/resources/router.const'

export default [
  {
    path: 'my',
    components: {
      myPooqLayout: () => import('@/pages/section/MyPooqLayout'),
    },
    children: [
      {
        path: '',
        name: PATH_NAME_MY,
        meta: { uiCode: UI_CODE.MY, section: PATH_NAME_MY },
        alias: 'index.html',
        components: {
          myPooqContent: () =>
            import(/* webpackChunkName: "mypooq_index" */ '@/pages/mypooq'),
        },
        beforeEnter: beforeGNBEnter,
      },
      {
        path: 'use_list_vod_history',
        name: PATH_NAME_USE_LIST_VOD_HISTORY,
        meta: { menu: 'history', title: '시청내역' },
        alias: 'use_list_vod_history.html',
        components: {
          myPooqContent: () =>
            import(
              /* webpackChunkName: "use_list_vod_history" */ '@/pages/mypooq/use_list_vod_history'
            ),
        },
      },
      {
        path: 'use_list_movie_history',
        name: PATH_NAME_USE_LIST_MOVIE_HISTORY,
        meta: { menu: 'history', title: '시청내역' },
        alias: 'use_list_movie_history.html',
        components: {
          myPooqContent: () =>
            import(
              /* webpackChunkName: "use_list_movie_history" */ '@/pages/mypooq/use_list_movie_history'
            ),
        },
      },
      {
        path: 'use_list_download',
        name: PATH_NAME_USE_LIST_DOWNLOAD_HISTORY,
        meta: { menu: '', title: '다운로드 관리' },
        alias: 'use_list_download.html',
        components: {
          myPooqContent: () =>
            import(
              /* webpackChunkName: "use_list_download" */ '@/pages/mypooq/use_list_download'
            ),
        },
      },
      {
        path: 'like_channel',
        name: PATH_NAME_LIKE_CHANNEL,
        alias: 'like_channel.html',
        components: {
          myPooqContent: () =>
            import(
              /* webpackChunkName: "like_channel" */ '@/pages/mypooq/like_channel'
            ),
        },
      },
      {
        path: 'like_theme',
        name: PATH_NAME_LIKE_THEME,
        meta: { menu: '', title: '관심 에디터Pick' },
        alias: 'like_theme.html',
        components: {
          myPooqContent: () =>
            import(
              /* webpackChunkName: "like_theme" */ '@/pages/mypooq/like_theme'
            ),
        },
      },
      {
        path: 'like_program',
        name: PATH_NAME_LIKE_PROGRAM,
        meta: { menu: '', title: '관심 프로그램' },
        alias: 'like_program.html',
        components: {
          myPooqContent: () =>
            import(
              /* webpackChunkName: "like_program" */ '@/pages/mypooq/like_program'
            ),
        },
      },
      {
        path: 'like_movie',
        name: PATH_NAME_LIKE_MOVIE,
        meta: { menu: '', title: '관심 영화' },
        alias: 'mypooq/like_movie.html',
        components: {
          myPooqContent: () =>
            import(
              /* webpackChunkName: "like_movie" */ '@/pages/mypooq/like_movie'
            ),
        },
      },
      {
        path: 'reserve_watch',
        name: PATH_NAME_RESERVE_WATCH,
        meta: { menu: '', title: '시청 예약' },
        alias: 'reserve_watch.html',
        components: {
          myPooqContent: () =>
            import(
              /* webpackChunkName: "reserve_watch" */ '@/pages/mypooq/reserve_watch'
            ),
        },
      },
      {
        path: 'voucher_list_singular',
        name: PATH_NAME_VOUCHER_LIST_SINGULAR,
        meta: { menu: 'voucher', title: '구매콘텐츠' },
        alias: 'voucher_list_singular.html',
        components: {
          myPooqContent: () =>
            import(
              /* webpackChunkName: "voucher_list_singular" */ '@/pages/mypooq/voucher_list_singular'
            ),
        },
      },
      {
        path: 'voucher_list_package',
        name: PATH_NAME_VOUCHER_LIST_PACKAGE,
        meta: { menu: 'voucher', title: '구매콘텐츠' },
        alias: 'voucher_list_package.html',
        components: {
          myPooqContent: () =>
            import(
              /* webpackChunkName: "voucher_list_package" */ '@/pages/mypooq/voucher_list_package'
            ),
        },
      },
      {
        path: 'subscription_ticket',
        name: PATH_NAME_SUBSCRIPTION_TICKET,
        meta: { menu: '', title: '이용권내역' },
        alias: 'subscription_ticket.html',
        components: {
          myPooqContent: () =>
            import(
              /* webpackChunkName: "subscription_ticket" */ '@/pages/mypooq/subscription_ticket'
            ),
        },
      },
      {
        path: 'coin',
        name: PATH_NAME_COIN,
        meta: { menu: '', title: '코인내역' },
        alias: 'coin.html',
        components: {
          myPooqContent: () =>
            import(/* webpackChunkName: "coin" */ '@/pages/mypooq/coin'),
        },
      },
      {
        path: 'coupon',
        name: PATH_NAME_COUPON,
        meta: { menu: '', title: '쿠폰내역' },
        alias: 'coupon.html',
        components: {
          myPooqContent: () =>
            import(/* webpackChunkName: "coupon" */ '@/pages/mypooq/coupon'),
        },
      },
      {
        path: 'device-history',
        name: PATH_NAME_DEVICE_HISTORY,
        // my-pooq-layout에서 my-pooq-title을 미노출하기 위해 hideTitle: true 설정
        meta: { hideTitle: true },
        alias: 'device-history.html',
        components: {
          myPooqContent: () =>
            import(
              /* webpackChunkName: "device_history" */ '@/pages/mypooq/DeviceHistory'
            ),
        },
      },
    ],
    beforeEnter: (to, from, next) => {
      if (cookie.getCredential() === 'none') {
        next({ path: `/member/login?referer=${to.fullPath}`, replace: true })
      } else {
        next()
      }
    },
  },
]
